import { AutomaticReturns } from '../../presentation/redux/types/settings-types';
import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.automatic_returns`. */
export const editAutomaticReturns = async (automatic_returns: AutomaticReturns): Promise<any> =>
  writeSettingsFields({ automatic_returns });
